import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Popover — Radix's, wrapped.
 *
 * A popover holds interactive content (a form, a list of actions), unlike a tooltip, which holds a
 * sentence. It takes focus when it opens and returns it when it closes, so the keyboard never ends
 * up somewhere it cannot get back from.
 *
 * `label` names the popover itself. A panel that appears out of nowhere with no name is hard to
 * make sense of when it is read aloud rather than seen.
 */
import * as RadixPopover from '@radix-ui/react-popover';
import { cx } from '../lib/cx.js';
import { usePortalContainer } from '../theme/theme-provider.js';
export function Popover({ trigger, label, side = 'bottom', align = 'start', open, defaultOpen, onOpenChange, className, children, }) {
    const container = usePortalContainer();
    return (_jsxs(RadixPopover.Root, { open: open, defaultOpen: defaultOpen, onOpenChange: onOpenChange, children: [_jsx(RadixPopover.Trigger, { asChild: true, children: trigger }), _jsx(RadixPopover.Portal, { container: container, children: _jsx(RadixPopover.Content, { className: cx('clav-popover__content', className), side: side, align: align, sideOffset: 6, collisionPadding: 8, "aria-label": label, children: children }) })] }));
}
export const PopoverClose = RadixPopover.Close;
//# sourceMappingURL=popover.js.map